<template>
  <div class="card" v-show="currentCardId == 'skills'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>スキルを入力</h2>
        <p>スキルと熟練度を入力してください</p>
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <SkillItem
              v-for="(item, index) in formatData.skills"
              :key="item.uuid"
              :item="item"
              :length="(formatData.skills && formatData.skills.length) || 0"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'スキル名を入力'"
              :descriptionMaxLength="descriptionMaxLength"
              @click.native="activateHistoryItem(item.uuid)"
              @add-skill-item="addSkills"
              @delete-skill-item="deleteSkills"
              @move-skill-item="moveSkills"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addSkills()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SkillItem from '@/components/formats/RirekishoParts/SkillItem.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useDesignRirekishoSkills } from '@/composables/format-edit/useDesignRirekishoSkills'
import type { BasicData } from '@/utils/format-edit/basicData'

defineProps<{
  currentCardId?: string
  basicData: BasicData
}>()

const descriptionMaxLength = 80
const formatData = useRirekishoFormatData()
const {
  activeHistoryItem,
  addSkills,
  deleteSkills,
  moveSkills,
  activateHistoryItem
} = useDesignRirekishoSkills(formatData)
</script>
